import Button from "./button";

const DiscordBotButton = () => {
  const client = "?client_id=847775163105148958"
  const permissionsString = "&permissions=268830720"
  // const redirect = "&redirect_uri=https%3A%2F%2Fprepi.io%2Flogin"
  // const response = "&response_type=code"
  const scope = "&scope=applications.commands%20bot"
  
  return (
    <a href={`https://discord.com/api/oauth2/authorize${client}${permissionsString}${scope}`} target="_blank" >
      <Button 
        text="Get Discord bot"
        // colorHex="#5865F2"
        // colorHexHover="#7984F5"
        size="small"
        addClass="clickable mb1"
        iconLeft={{
          icon: "discord",
          imgURL: `/img/discordIconWhite.png`
        }}
      />
    </a>
  );
}

export default DiscordBotButton;